"use strict";
var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var { Input } = require("react-bootstrap");
var CompanyStore = require("../../../stores/CompanyStore");
var CompanyActions = require("../../../actions/CompanyActions");
var _ = require("underscore");
import { GoogleMapLoader, GoogleMap, Marker } from "react-google-maps";
import MapIcon from '../../../../images/icons/map-location.png';

var LocationForm = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    var locations = CompanyStore.getState().locations;

    return {
      id: this.props.location && this.props.location.id || "",
      name: this.props.location && this.props.location.name || this.props.name || "",
      parent: this.props.parent ? this.props.parent.id : (this.props.location && this.props.location.parent || ""),
      latitude: this.props.location && this.props.location.latitude || 64.146656,
      longitude: this.props.location && this.props.location.longitude || -21.898074,
      locations: locations,
      hasSubmitted: false,
      formValidation: {
        nameValid: false,
      }
    };
  },
  onSubmit() {
    if (this.state.name === '') {
      this.setState({
        hasSubmitted: true,
        formValidation: {
          nameValid: this.state.name !== '',
        },
      });
    } else {
      this.props.onHide();
      // Initialize location object.
      var newLocation = {
        "name": this.state.name.indexOf(',') !== -1 ?
          this.state.name.substring(0, this.state.name.indexOf(',')) :
          this.state.name,
        "parent": this.state.parent,
        "latitude": this.state.latitude,
        "longitude": this.state.longitude
      };

      if (this.props.location) {
        // In edit mode
        // Create data object.
        var dataObject = {
          "id": this.state.id,
          "body": newLocation
        }

        // Trigger an update request to the server.
        CompanyActions.updateLocation(dataObject);
      } else {
        // In add mode
        // Trigger a create request to the server.
        CompanyActions.addLocation(newLocation);
      }
    }
  },
  mapLocations: function(location, key) {
    if (!this.props.location) {
      return (<option key={key} value={location.id}>{location.name}</option>);
    } else if (location.id !== this.props.location.id) {
      return (<option key={key} value={location.id}>{location.name}</option>);
    } else {
      return null;
    }
  },
  onDragend: function(e) {
    if (e.latLng) {
      this.setState({
        latitude: e.latLng.lat().toFixed(4),
        longitude: e.latLng.lng().toFixed(4)
      });
    }
  },
  onSuggestSelect: function(e) {
    if (e.location) {
      this.setState({
        latitude: e.location.lat.toFixed(4),
        longitude: e.location.lng.toFixed(4),
        name: e.label
      })
    }
  },
  render: function() {
    return (
      <div className="modal-body">
        <Input
          label="Heimilisfang *"
          type="text"
          initialValue={this.state.name}
          inputClassName={`form-control${(this.state.hasSubmitted && !this.state.formValidation.nameValid) ? ' error' : ''}`}
          placeholder="Heimilsfang"
        />
        <Input label="Foreldri" type="select" valueLink={this.linkState("parent")}>
          <option key="default" value="">Ekkert foreldri</option>
          {_.map(this.state.locations, this.mapLocations)}
        </Input>
        <div className="item-map">
          <GoogleMapLoader
             containerElement={
               <div
                 style={{ height: '300px' }}
               />
             }
             googleMapElement={
               <GoogleMap
                 defaultZoom={15}
                 center={{
                   lat: parseFloat(this.state.latitude),
                   lng: parseFloat(this.state.longitude)
                 }}
                 defaultOptions={{ disableDefaultUI: true }}
               >
                <Marker
                  onDragend={this.onDragend}
                  position={{
                    lat: parseFloat(this.state.latitude),
                    lng: parseFloat(this.state.longitude)
                  }}
                  icon={MapIcon}
                  cursor="pointer"
                  draggable
                />
               </GoogleMap>
             }
          />
        </div>
      </div>
    );
  }
});

module.exports = LocationForm;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Locations/LocationForm.js